import { Injectable } from '@angular/core';

import { Observable, Observer } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { ReplaySubject, Subject } from 'rxjs/';

import { CommunicationService } from './communication.service';
import { BasicError } from '../models/error/error';

@Injectable()
export class RegisterService {
  private registerUrl: String = '/api/v1/auth/register';
  private resendVerificationUrl: String = '/api/v1/auth/verify/resend';
  private requestPWResetInstructionsUrl: String = '/api/v1/auth/password/reset/instructions';
  private setNewPasswordUrl: String = '/api/v1/auth/password/reset';
  private verifyTokenUrl: String = '/api/v1/auth/verify/token/';

  constructor(private communication: CommunicationService) { }

  // The normal functionality
  public registerUserShort(userName: String, email: String, password: String, passwordConf: String) {
    const retReplay = new Subject();

    const payload = {
      'data': {
        'type': 'users',
        'attributes': {
        }
      }
    };

    // Compare data to payload
    if (email !== '') {
      payload.data.attributes['email'] = email;
    }

    if (userName !== '') {
      payload.data.attributes['name'] = userName;
    }

    if (password !== '' && password === passwordConf) {
      payload.data.attributes['password'] = password;
    }

    if (passwordConf !== '' && password === passwordConf) {
      payload.data.attributes['password_confirmation'] = passwordConf;
    }

    // Post the new User
    this.communication.post(this.registerUrl, payload).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('--------RegisterServcie---------: Failed to register new User.');
        console.log(data);
        retReplay.next(data);
      } else {
        retReplay.next(true);
      }
    });

    return retReplay;
  }

  // Special Functionality. Register User with all data
  public registerUser(firstName: String, lastName: String, userName: String, email: String, sex: String,
    password: String, passwordConf: String) {
    const retReplay = new Subject();

    const payload = {
      'data': {
        'type': 'users',
        'attributes': {
        }
      }
    };

    // Compare data and add it to payload
    if (firstName !== '') {
      payload.data.attributes['firstname'] = firstName;
    }

    if (lastName !== '') {
      payload.data.attributes['lastname'] = lastName;
    }

    if (email !== '') {
      payload.data.attributes['email'] = email;
    }

    if (userName !== '') {
      payload.data.attributes['name'] = userName;
    }

    if (sex !== '') {
      payload.data.attributes['sex'] = sex;
    }

    if (password !== '' && password === passwordConf) {
      payload.data.attributes['password'] = password;
    }

    if (passwordConf !== '' && password === passwordConf) {
      payload.data.attributes['password_confirmation'] = passwordConf;
    }

    // Post the new User
    this.communication.post(this.registerUrl, payload).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('--------RegisterServcie---------: Failed to register new User.');
        console.log(data);
        retReplay.next(data);
      } else {
        retReplay.next(true);
      }
    });

    return retReplay;
  }


  public resendVerification(email: String) {
    const retReplay = new Subject();

    const payload = {
      'data': {
        'type': 'users',
        'attributes': {
        }
      }
    };

    // Compare data and add it to payload
    if (email !== '') {
      payload.data.attributes['email'] = email;
    }

    this.communication.post(this.resendVerificationUrl, payload).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('--------RegisterServcie---------: Failed to send verification.');
        console.log(data);
        retReplay.next(data);
      } else {
        retReplay.next(true);
      }
    });

    return retReplay;
  }


  public requestPWResetInstructions(email: String) {
    const retReplay = new Subject();

    const payload = {
      'data': {
        'type': 'users',
        'attributes': {
        }
      }
    };

    // Compare data and add it to payload
    if (email !== '') {
      payload.data.attributes['email'] = email;
    }

    this.communication.post(this.requestPWResetInstructionsUrl, payload).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('--------RegisterServcie---------: Failed to request for a new password.');
        console.log(data);
        retReplay.next(data);
      } else {
        retReplay.next(true);
      }
    });

    return retReplay;
  }


  public setNewPassword(password: String, passwordConf: String, token: String) {
    const retReplay = new Subject();

    const payload = {
      'data': {
        'type': 'users',
        'attributes': {
        }
      }
    };

    // Compare data and add it to payload
    if (token !== '') {
      payload.data.attributes['reset_token'] = token;
    }

    if (password !== '') {
      payload.data.attributes['password'] = password;
    }

    if (passwordConf !== '') {
      payload.data.attributes['password_confirmation'] = passwordConf;
    }

    this.communication.post(this.setNewPasswordUrl, payload).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('--------RegisterServcie---------: Failed to set a new password.');
        console.log(data);
        retReplay.next(data);
      } else {
        retReplay.next(true);
      }
    });

    return retReplay;
  }

  public verifyToken(token: String) {
    if (token === undefined || token === null) {
      const temp = new ReplaySubject(1);
      temp.next(false);
      return temp;
    }

    const retReplay = new Subject();
    this.communication.get(this.verifyTokenUrl + token.toString()).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('--------RegisterServcie---------: Failed to verify token.');
        console.log(data);
        retReplay.next(data);
      } else {
        retReplay.next(true);
      }
    });

    return retReplay;
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/services/register.service.ts